import React from "react";
import { useParams } from "react-router-dom";
import useScrollToTop from "../components/useScrollToTop";
import Navbar from "../components/Navbar";

const PaymentPage = () => {
  useScrollToTop();
  const { price } = useParams(); // Get room ID from URL
  const hotelBankDetails = {
    bankName: "Zenith Bank",
    accountName: "Grand Royal Hotel",
    accountNumber: "1234567890",
  };

  const whatsappNumber = "2348012345678"; // Change this to the hotel's WhatsApp number
  const message = encodeURIComponent(
    `Hello, I have made a payment. Here is my proof of payment:`
  );
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <>
      <Navbar current="payment" />
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-800 p-4">
        <div className="bg-white shadow-lg rounded-lg p-6 max-w-md w-full text-center">
          <h1 className="text-2xl font-bold mb-4 text-gray-800">
            Payment Details
          </h1>
          <div className="text-left text-gray-700 space-y-2">
            <p>
              <span className="font-semibold">Bank Name:</span>{" "}
              {hotelBankDetails.bankName}
            </p>
            <p>
              <span className="font-semibold">Account Name:</span>{" "}
              {hotelBankDetails.accountName}
            </p>
            <p>
              <span className="font-semibold">Account Number:</span>{" "}
              {hotelBankDetails.accountNumber}
            </p>
            <p>
              <span className="font-semibold">Amount:</span> ₦{price}
            </p>
          </div>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-block bg-green-600 text-white py-2 px-4 rounded-lg shadow hover:bg-green-700 transition duration-300"
          >
            Send Proof of Payment
          </a>
        </div>
      </div>
    </>
  );
};

export default PaymentPage;
